<div class="modal-header pb-2">
  <p class="modal-title mt-4">Sort & Filter</p>
  <button type="button" class="close fs-16" (click)="cancelFilter()" aria-label="Close">Cancel</button>
</div>
<div class="modal-body fixed-header fixed-footer form" *ngIf="searchRequest">
  <div class="form-group">
    <label>Sort by</label>
    <common-dropdown
      customClass="form-control"
      [dropDownItems]="orderByDropDownItems"
      [selectedValue]="searchRequest.orderBy.selectedOrderBy"
      (selectedValueChange)="filter()"
    ></common-dropdown>
  </div>

  <div class="form form-group job-location-container" *ngIf="searchRequest.location.location != null">
    <label for="location">Location Radius</label>
    <common-dropdown
      [dropDownItems]="searchRequest.location.radiusOptions"
      [selectedValue]="searchRequest.location.selectedRadius"
      (itemSelected)="filter()"
      customClass="form-control btn-white"
    >
    </common-dropdown>
  </div>

  <!-- RPO -->
  <div class="form-group" *ngIf="searchRequest.rpoEnabled.facets?.length || searchRequest.buyItNowEnabled.facets?.length">
    <label for="rpo">Purchase Options</label>
    <app-facet-checkbox-group [facetGroup]="searchRequest.isTopOwner.facets" [showBorderBottom]="false" (checkboxChange)="filter()"></app-facet-checkbox-group>
    <app-facet-checkbox-group
      [facetGroup]="searchRequest.buyItNowEnabled.facets"
      [showBorderBottom]="false"
      (checkboxChange)="buyItNowOrRtoChange()"
    ></app-facet-checkbox-group>

    <app-facet-checkbox-group [facetGroup]="searchRequest.rpoEnabled.facets" (checkboxChange)="buyItNowOrRtoChange()"></app-facet-checkbox-group>
  </div>

  <!-- Model -->
  <app-facet-checkbox-group [facetGroup]="searchRequest.model.facets" facetName="Model" (checkboxChange)="filterModel()"> </app-facet-checkbox-group>

  <!-- Start of attachments -->
  <div
    class="form-group"
    data-type="checkbox"
    *ngIf="searchRequest.attachment.catalogs.facets.length > 1 || searchRequest.attachment.catalogs.selected || searchRequest.attachment.specs.selected"
  >
    <app-facet-checkbox-group
      [facetGroup]="searchRequest.attachment.catalogs.facets"
      [facetSubGroup]="searchRequest.attachment.specs.facets"
      facetName="Attachment"
      (checkboxChange)="filter()"
      [useLabelWhenOne]="true"
      [useSingleState]="true"
    >
    </app-facet-checkbox-group>
  </div>
  <!-- end of attachments -->

  <!-- Hours -->
  <app-facet-range-slider [facetRange]="searchRequest.hours.slider" facetName="Hours" useCommas="true" (rangeSliderChange)="filter()"></app-facet-range-slider>

  <!-- Weight -->
  <app-facet-range-slider
    [facetRange]="searchRequest.weight.slider"
    facetName="Weight"
    useCommas="true"
    (rangeSliderChange)="filter()"
  ></app-facet-range-slider>

  <!-- Horse Power -->
  <app-facet-range-slider
    [facetRange]="searchRequest.enginePower.slider"
    facetName="Horsepower"
    [useCommas]="true"
    (rangeSliderChange)="filter()"
  ></app-facet-range-slider>

  <!-- Year -->
  <app-facet-range-slider [facetRange]="searchRequest.year.slider" facetName="Year" (rangeSliderChange)="filter()"></app-facet-range-slider>
</div>
<div class="modal-footer fixed-bottom bg-white">
  <button type="button" class="btn" (click)="clearFilter()">Clear</button>
  <button class="btn btn-secondary btn-mobile-lg ml-auto w-50" (click)="apply()">Show results</button>
</div>
